import { useCallback, useEffect } from "react";
export var useDraggedScroll = function () {
    var windowScrollCallback = useCallback(function (e) {
        var y = e.clientY;
        if (y < window.innerHeight * 0.1) {
            window.scrollTo(0, window.scrollY - 0.01 * window.innerHeight);
        }
        else if (y > window.innerHeight * 0.9) {
            window.scrollTo(0, window.scrollY + 0.01 * window.innerHeight);
        }
    }, []);
    useEffect(function () {
        window.addEventListener("dragover", windowScrollCallback);
        return function () {
            window.removeEventListener("dragover", windowScrollCallback);
        };
    }, []);
};
//# sourceMappingURL=useDraggedScroll.js.map